import Button, { ButtonProps } from "atoms/buttons/button";
import Icon from "atoms/icons/icon";
import React, { forwardRef } from "react";
import { Icons } from "atoms/constants/icons";
import { useLocalization } from "utilities/hooks/use-localization";
import { IconSizes } from "atoms/constants/icon-sizes";
import NotebookRecord from "models/view-models/notebook-record";

export interface DeleteNotebookMenuItemProps extends ButtonProps {
    onClick: () => void;
    notebook: NotebookRecord;
    canDelete: boolean;
}

const DeleteNotebookMenuItem = forwardRef<
    HTMLButtonElement,
    DeleteNotebookMenuItemProps
>((props, ref) => {
    const { onClick, children, canDelete, ...rest } = props;
    const { t } = useLocalization();

    return (
        canDelete && (
            <Button
                ref={ref}
                accessibleText={t("deleteItem", {
                    item: t("notebook"),
                })}
                cssClassName={"-icon-left delete-button"}
                onClick={onClick}
                {...rest}>
                <Icon type={Icons.Trashcan} size={IconSizes.Small} />
                {t("deleteItem", {
                    item: t("notebook"),
                })}
            </Button>
        )
    );
});

export default DeleteNotebookMenuItem;
